import { call, put, takeEvery } from 'redux-saga/effects'
import { AsyncAction } from 'src/utils/reduxUtils'
import { StitchStartFlow, StitchCompletePayment, FetchDriver } from 'src/constants/actionTypes'
import { ApiService, callClientSecureApi } from './api/callApi'
import { Endpoints } from 'src/constants/endpoints'
import { captureSentryError } from 'src/utils/sentry'

interface StitchStartFlowRequest {
  stepId: string
}

interface StitchStartFlowResponse {
  token: string
}

function* onStitchStartFlow(action: AsyncAction<StitchStartFlowRequest, StitchStartFlowResponse>) {
  try {
    const { stepId } = action.payload

    const { payload }: { payload: StitchStartFlowResponse } = yield call(
      callClientSecureApi,
      Endpoints.StitchStartFlow,
      {
        apiService: ApiService.Paraworks,
        method: 'POST',
        body: {
          stepId,
        },
      },
    )

    yield put(StitchStartFlow.success())

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.stitch.onStitchStartFlow] error',
    })

    const errorMessage = err?.payload?.message || 'Failed to fetch stitch token'

    yield put(StitchStartFlow.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

interface StitchCompletePaymentRequest {
  stepId: string
}

function* onStitchCompletePayment(action: AsyncAction<StitchCompletePaymentRequest>) {
  const { stepId } = action.payload

  try {
    yield call(callClientSecureApi, Endpoints.StitchCompletePayment, {
      apiService: ApiService.Paraworks,
      method: 'POST',
      body: {
        stepId,
      },
    })

    yield put(StitchCompletePayment.success())
    yield put(FetchDriver.request())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.stitch.onStitchCompletePayment] error',
    })

    const errorMessage = err?.payload?.message || 'Failed to complete payment'

    yield put(StitchCompletePayment.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* stitchSaga() {
  yield takeEvery(StitchStartFlow.type.REQUEST, onStitchStartFlow)
  yield takeEvery(StitchCompletePayment.type.REQUEST, onStitchCompletePayment)
}
